import { API } from "../conflict";
const data = {
    1: "create",
    2: "update",
    3: "delete"
}

export const PostStoreLog = (action_type, log_detail) => {
     
    API.post("logs", {
      action_type: data[parseInt(action_type)],
      log_detail: log_detail,
      module: "Administation",
      submodule: "store",
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  



